export const USER_RATING_LEVELS = [
  { level: 1, label: "Beginner", unlock: null },
  { level: 2, label: "Hobbyist", unlock: null },
  { level: 3, label: "Apprentice", unlock: null },
  { level: 4, label: "Journeyman", unlock: null },
  { level: 5, label: "Expert", unlock: null },
  { level: 6, label: "Pro", unlock: null },
  { level: 7, label: "Master", unlock: null },
  { level: 8, label: "Legend", unlock: null },
  { level: 9, label: "God", unlock: null },
];
const levelThresholds = [0, 5, 20, 65, 155, 515, 2015, 8015, 33015];

export const calculateLevelAndProgress = (score: number) => {
  let level = 1;
  for (let i = levelThresholds.length - 1; i >= 0; i--) {
    if (score >= levelThresholds[i]) {
      level = i + 1;
      break;
    }
  }

  const isMax = level === 9;
  const currentExp = score - levelThresholds[level - 1];
  const maxExp = isMax ? null : levelThresholds[level] - levelThresholds[level - 1];
  const toNext = isMax ? null : levelThresholds[level] - score;

  return { level, currentExp, maxExp, toNext };
};
